var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4023 2.35938C19.1406 3.13281 19.1406 4.36328 18.4023 5.13672L7.39844 16.1406C6.97656 16.5273 6.48438 16.8438 5.95703 16.9844L1.70312 18.25C1.49219 18.2852 1.28125 18.25 1.14062 18.1094C1 17.9688 0.929688 17.7578 1 17.5469L2.26562 13.293C2.40625 12.7656 2.72266 12.2734 3.10938 11.8516L14.1133 0.847656C14.8867 0.109375 16.1172 0.109375 16.8906 0.847656L18.4023 2.35938ZM12.9883 3.58984L15.6602 6.26172L17.5938 4.36328C17.9102 4.01172 17.9102 3.48438 17.5938 3.16797L16.082 1.65625C15.7656 1.33984 15.2383 1.33984 14.8867 1.65625L12.9883 3.58984ZM12.1797 4.36328L3.91797 12.6602C3.63672 12.9062 3.42578 13.2578 3.32031 13.6094L2.37109 16.8789L5.64062 15.9297C5.99219 15.8242 6.34375 15.6133 6.58984 15.332L14.8516 7.07031L12.1797 4.36328Z",
    fill: "#001247"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencil);
export default __webpack_public_path__ + "static/media/icon-pencil.aee78a32.svg";
export { ForwardRef as ReactComponent };